<template>
  <app-chip
    v-if="displayRemainingSeats"
    class="bg-deco2"
    icon="ph:warning-circle"
    size="small"
  >
    {{
      $t("course.session.remaining_seats_label", {
        count: session.remaining_seats!,
      })
    }}
  </app-chip>
</template>

<script lang="ts" setup>
import { differenceInCalendarDays } from "date-fns";

import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

const properties = defineProps<{
  session: CourseSessionView;
}>();

/*
Rules to display the remaining seats warning :

  - session starts in more than 3 days AND remaining seats <= 5
  - session starts in less than 3 days AND remaining seats === 1

*/
const displayRemainingSeats = computed(() => {
  const remainingSeatsWarningLimit =
    differenceInCalendarDays(
      new Date(properties.session.start_date!),
      new Date(),
    ) > 3
      ? 5
      : 1;

  return (
    properties.session.remaining_seats! > 0 &&
    properties.session.remaining_seats! <= remainingSeatsWarningLimit
  );
});
</script>
